export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DOCS_LINK = "https://jellyfin.org/docs";
export const GITHUB_LINK = "https://github.com/jellyfin/jellyfin";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
